var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { TextButton } from "@irati/ui/src/Button";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  background-color: #999;\n  color: white;\n  padding: 2px;\n  padding-left: 10px;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  background-color: #999;\n  color: white;\n  padding: 2px;\n  padding-left: 10px;\n"])));
var Padding = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 10px;\n  ", " {\n    text-decoration: underline;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"], ["\n  padding: 0 10px;\n  ", " {\n    text-decoration: underline;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"])), TextButton);
var VersionRow = /** @class */ (function (_super) {
    __extends(VersionRow, _super);
    function VersionRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VersionRow.prototype.render = function () {
        var _a = this.props, text = _a.text, value = _a.value, onClear = _a.onClear;
        return (React.createElement(Wrapper, null,
            React.createElement(Padding, null,
                text,
                " = ",
                value),
            "|",
            React.createElement(Padding, null,
                React.createElement(TextButton, { inline: true, onClick: onClear }, "Clear"))));
    };
    return VersionRow;
}(PureComponent));
export default VersionRow;
var templateObject_1, templateObject_2;
